export default "__VITE_ASSET__CBWVKM7f__"